import React, {useEffect, useMemo, useState} from 'react'
import { useHistory } from 'react-router';
import moment from 'moment';

import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {EndorsementsContainer} from "../AvailableJobPage/components/index";
import {
    Page,
    Title,
    ShiftBox,
    ButtonBox,
    ShiftBoxTime,
    ShiftBoxDate,
    TitleContainer,
    SubtitleSecondary,
    StatusBoxPending,
    OfferRate,
    OfferRateWrapper,
    OfferTimerWrapper
} from "../ShiftDetailPage/ShiftDetail.styles";
import styles from "../ShiftDetailPage/ShiftDetail.module.scss";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import ScheduleOutlinedIcon from "@material-ui/icons/ScheduleOutlined";
import heartFilled from "../../../images/heartFilled.svg";
import heartUnfilled from "../../../images/heartUnfilled.svg";
import {Icon} from "../AvailableJobsPage/AvailableJobsPage.styles";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import { OfferTimer } from 'components/OfferTimer';


import {
    convertDentalOfficeStatus,
    AccordionExpandIcon,
    ResubmitShiftModal, ShiftPopup, MapButton,
} from "../ShiftDetailPage/components";
import Api from "../../../api";
import {exitReact} from "../../../utils";
import _ from "lodash";
import useActionApi from "../../../hooks/useActionApi";
import {usePersistedState} from "../../../hooks";
import { HygienistProps, JobProps } from "utils/types";
import {entities} from "../../../reduxStore";
import Popup from "../../../components/Popup";
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";
import HideSourceIcon from "@mui/icons-material/HideSource";
import clsx from "clsx";
import {JOB_STATUSES, PARTIAL_OFFER_STATUS} from "utils/constants";

dayjs.extend(isToday)

const PartialOfferPage = () => {
    const [trackData, setTrackData] = useState<any>(null);
    const [updatingJob, setUpdatingJob] = useState<boolean>(false);

    const history = useHistory();
    const {jobId, job: jobData } = history.location.state as any
    const [job, setJob] = useState(jobData || {} as any)
    const [isFavouriteDentist, setFavouriteDentist] = useState<boolean>(jobData?.isFavouriteDentist || false)
    const [isOpenRemoveOfferModal, setIsOpenRemoveOfferModal] = useState<boolean>(false);

    const hygienist = usePersistedState<HygienistProps>({
        entityName: entities.hygienist
    })[0];

    const offer = useMemo(() => {
        if(!_.isEmpty(job))
            return job?.partialOffers?.findLast((offer: any) => offer.hygienistId === hygienist.id)
    }, [job]);

    const expiredOfferId = useMemo(() => {
        return job?.partialOffers?.find((offer: any) => offer.hygienistId === hygienist.id
            && offer.status === PARTIAL_OFFER_STATUS.EXPIRED)?.id
    }, [job])

    const removeOffer = async () => {
        setIsOpenRemoveOfferModal(true)
    }

    const [getJobDetailsLoading, , getJobDetails] = useActionApi({
        apiMethod: Api.getJobDetails,
        onSuccess: (jobObj: any) => {
            if(_.isEmpty(jobObj)) return
            setJob(jobObj)
        },
    });

    const [checkFavouriteLocationLoading, , checkFavouriteLocation] = useActionApi({
        apiMethod: Api.checkFavouriteLocation,
        onSuccess: (data: any) => {
            setFavouriteDentist(data.isFavouriteDentist)
        },
    });

    const [removePartialOfferLoading, , removePartialOffer] = useActionApi({
        apiMethod: Api.removePartialOffer,
        onSuccess: () => {
            history.push('loading')
            exitReact('home')
        },
    });

    useEffect(() => {
        if(_.isEmpty(jobData) && jobId) {
            getJobDetails(jobId)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(job)) {
            setTrackData({
                isInstabookEnabled: !!job.Instabook,
                recommendedHourlyRate: job.proposedRate,
                currencyCode: job.location.country ? 'USD' : 'CAD',
                dentalOfficeLocationId: job.locationId,
                dentalOfficeId: job.dentistId,
                dentalOfficeStatus: convertDentalOfficeStatus(job.location.status),
                shiftStartDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedStart).toISOString(),
                shiftEndDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedEnd).toISOString(),
                shiftId: job.shifts[0].id,
                shiftPostDate: new Date(job.postedOn).toISOString(),
            })
            checkFavouriteLocation(job.locationId)
        }
    }, [job]);

    const updateFavourite = async ({ dentistId, locationId }: JobProps) => {
        setUpdatingJob(true)
        if (isFavouriteDentist) {
            await Api.removeFavouriteDentistByLocationId(locationId);
        } else {
            await Api.setFavouriteDentist(dentistId, locationId);
        }
        checkFavouriteLocation(locationId)
        setUpdatingJob(false);
    }

    const isGuaranteedRate = useMemo(() => !!job?.ghr, [job])
    const hourlyRate = useMemo(() => {
        return isGuaranteedRate ? `$${job.ghr}/hr Guaranteed`
            : `$${offer?.hourlyRate}/hr`}, [isGuaranteedRate, job])

    const formatTime = (timeStr: string | undefined): string => {
        if (!timeStr) return '';
        
        if (timeStr.includes('am') || timeStr.includes('pm') || timeStr.includes('AM') || timeStr.includes('PM')) {
            return timeStr;
        }
        
        const utcMoment = moment.utc(timeStr);
        return utcMoment.isValid() ? utcMoment.local().format('h:mm A') : timeStr;
    };

    return (<>
        <TopBarRedesigned
            title={'Partial Offer'}
            onBack={() => {
                history.push('loading')
                exitReact('home')
            }}
        />
        {!_.isEmpty(job) ? <Page>
            <TitleContainer>
                <Title>{job.location.practiceName}<Icon
                    style={{height: 22}}
                    src={isFavouriteDentist ? heartFilled : heartUnfilled}
                    onClick={() => updateFavourite(job)}
                /></Title>

                <ShiftBox>
                    <ShiftBoxDate>
                        <DateRangeOutlinedIcon className={styles.shiftDateIcon}/>
                        {dayjs(job.shifts[0].shiftDate).format('dddd MMM, D')}
                    </ShiftBoxDate>
                    <ShiftBoxTime>
                        <ScheduleOutlinedIcon className={styles.shiftDateIcon}/>
                        {`${offer?.offeredStartTimeLocal || formatTime(offer?.offeredStartTime)} - ${offer?.offeredEndTimeLocal || formatTime(offer?.offeredEndTime)}`}
                    </ShiftBoxTime>
                </ShiftBox>

                {JOB_STATUSES.PARTIAL === job.status ? <div className={styles.confirmedJobBox}>
                    <StatusBoxPending>
                        <WavingHandIcon className={styles.confirmedShiftIcon}/>
                        Offer Pending
                    </StatusBoxPending>
                </div> : null}

                <Popup opened={isOpenRemoveOfferModal} onClose={() => setIsOpenRemoveOfferModal(false)}>
                    <ShiftPopup
                        job={job}
                        close={'Cancel'}
                        title={'Remove Offer?'}
                        submit={'Remove Offer'}
                        onSubmit={() => {
                            removePartialOffer(offer?.id)
                        }}
                        onClose={() => setIsOpenRemoveOfferModal(false)}
                    />
                </Popup>

                <ResubmitShiftModal job={job} history={history} trackData={trackData} expiredOfferId={expiredOfferId}/>
                <OfferRateWrapper>
                    <SubtitleSecondary style={{opacity: 1}}>
                        {`${job.location.city}, ${job.location.province} ${job.location.postalCode}`}
                    </SubtitleSecondary>
                    <OfferTimerWrapper>
                        <OfferRate>{`Offer Rate: ${hourlyRate}`}</OfferRate>
                        {offer && <OfferTimer expiresAt={offer.expiresAt}/>}
                    </OfferTimerWrapper>
                </OfferRateWrapper>

                {/*<DistanceComponent job={job}/>*/}

                <ButtonBox>
                    <MapButton className={clsx(styles.removeCancelOfferButton, styles.mapBtn)} job={job}/>
                </ButtonBox>
            </TitleContainer>

            <EndorsementsContainer job={job} style={{margin: '1rem', background: 'none'}} />

            <AccordionExpandIcon job={job}/>

            <div className={styles.removeCancelOfferButtonBox}>
                <StyledButton
                    className={styles.removeCancelOfferButton}
                    variant="outlined"
                    startIcon={<HideSourceIcon/>}
                    color="primary"
                    size="large"
                    id="continue-button"
                    onClick={removeOffer}
                >Remove Offer</StyledButton>
            </div>

        </Page> : null}

        <FixedLoader
            loading={getJobDetailsLoading || checkFavouriteLocationLoading || updatingJob || removePartialOfferLoading}
        />
    </>)
}

export default PartialOfferPage;
